module.exports = __webpack_public_path__ + "img/315.de5b1b1e.png";